import { Dispatch } from 'react'
import { connect } from 'react-redux'

import OrdersColumn, { IStateProps, IDispatchProps, IOwnProps } from './OrdersColumn'

import { DashboardAction, setOpenCycle } from '../../services/store/actions/dashboard/DashboardAction'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {

  return {
    isRequesting: state.Dashboard.isRequesting,
    openCycles: state.Dashboard.openCycles,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction> ): IDispatchProps {
  return {
    setOpenCycle: (step:number, cycleCode:string) => dispatch(setOpenCycle({step, cycleCode})),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(OrdersColumn)
